import React from 'react';

import DrawerComponent from '@atlaskit/drawer';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import ProductStoreComponent from '@atlassiansox/product-store-react';
import CrossFlowIntegration from '@atlassiansox/cross-flow-react';

import { type IntegrationViewProps } from './types';
import { IntegrationView } from './view';
import { CompiledIntegrationView } from './compiled/view';

export default (props: IntegrationViewProps) => {
	// Cross-flow Support is also used in products outside of AFM (e.g. Bitbucket, Trello)
	// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
	const useCompiled = FeatureGates.checkGate('xflow_support_compiled_migration');
	if (useCompiled) {
		return (
			<CompiledIntegrationView
				{...props}
				ProductStoreComponent={ProductStoreComponent}
				CrossFlowComponent={CrossFlowIntegration}
			/>
		);
	}
	return (
		<IntegrationView
			{...props}
			// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
			DrawerComponent={DrawerComponent}
			ProductStoreComponent={ProductStoreComponent}
			CrossFlowComponent={CrossFlowIntegration}
		/>
	);
};
